(function () {
  if (innerWidth > 749) return;
  var root = ((window.N1M2 || {}).root || '/').replace(/\/$/, '');
  function start() {
    // account links: routes.root_url has no trailing slash on translated URLs
    document.querySelectorAll('.n1a__sub a').forEach(function (a) {
      var h = a.getAttribute('href'), m = h.match(/(pages|policies)\/.+$/);
      if (m) a.setAttribute('href', root + '/' + m[0]);
    });
    var l = document.querySelector('.n1a__sub .ksx-l10n'); if (l) l.open = true;
    var row = document.querySelector('.n1-buy__row'), pb = document.querySelector('[data-n1-pricebox]');
    if (row && pb) {
      var bp = document.createElement('div'); bp.className = 'n1m-bprice';
      var sync = function () { var p = pb.querySelector('[data-n1-price]'), s = pb.querySelector('[data-n1-compare]'); bp.innerHTML = '<b>' + p.innerHTML + '</b>' + (s && !s.hidden ? '<s>' + s.innerHTML + '</s>' : ''); };
      sync(); new MutationObserver(sync).observe(pb, { subtree: true, childList: true, characterData: true, attributes: true });
      row.insertBefore(bp, row.firstChild);
    }
    var t = document.querySelector('[id$="__rail_perf"] [data-n1-items]');
    if (t) {
      var low = /body|mist|lotion|cream|soap|deodor|hair|nail|polish/i;
      [].slice.call(t.children).forEach(function (c) { var a = c.querySelector('a[href*="/products/"]'); if (a && low.test(a.getAttribute('href'))) t.appendChild(c); });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
